export default {
  authx_app: state => state.authx_app
};
